// src/components/RoundSelection.js
import React from 'react';
import { BINGO_ROUNDS } from '../gameData'; // Assuming you created gameData.js
import './RoundSelection.css';

function RoundSelection({ onRoundSelect, onCancel }) {
  return (
    <div className="round-selection-overlay">
      <div className="round-selection-modal">
        <h2>Choose Your Bingo Round!</h2>
        {/* Instructions can remain or be removed if the larger buttons are self-explanatory */}
        <p className="round-selection-instructions">
          Select a round below to start the game.
        </p>
        <div className="round-cards-container">
          {BINGO_ROUNDS.map((round) => (
            <div
              key={round.id}
              className="round-card"
              onClick={() => onRoundSelect(round)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => e.key === 'Enter' && onRoundSelect(round)}
            >
              {/* Only display the round name, make it the primary content */}
              <h3>{round.name}</h3>
              {/* Removed: <p>{round.description}</p> */}
              {/* Removed: Pattern preview placeholder */}
            </div>
          ))}
        </div>
        <button className="cancel-round-selection-button" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
}

export default RoundSelection;
